export const SET_TEMP_STORE_DATA = 'SET_TEMP_STORE_DATA';

export const setTempStoreData = ({ data, identifier }) => ({
    type: SET_TEMP_STORE_DATA,
    payload: {
        data,
        identifier
    }
});
